import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { supabase } from './supabaseClient';

const C = { coral:'#eb636b', mango:'#FDBE02' };
const font = "'DM Sans', sans-serif";

const OPTIONS = [
  { value: null, label: 'Admin', emoji: '👑', path: '/admin' },
  { value: 'free_observer', label: 'Free Observer', emoji: '👁️', path: '/sala' },
  { value: 'tu_radar', label: 'Tu Radar', emoji: '🎯', path: '/escritorio/tu-radar' },
  { value: 'doer', label: 'Doer', emoji: '⭐', path: '/arbol' },
  { value: 'spark_seeker', label: 'Spark Seeker (legacy)', emoji: '⭐', path: '/arbol' },
  { value: 'momentum_builder', label: 'Momentum Builder', emoji: '🚀', path: '/escritorio/momentum' },
];

export default function AdminViewSwitcher() {
  const { isAdmin, user, viewAs, setViewAs, refreshProfile } = useAuth();
  const navigate = useNavigate();
  if (!isAdmin) return null;

  const handleChange = (val) => {
    const selected = OPTIONS.find(o => (o.value || '') === val);
    setViewAs(val || null);
    setTimeout(() => { if (selected?.path) navigate(selected.path); }, 50);
  };

  const resetOnboarding = async () => {
    if (!window.confirm('¿Resetear tu perfil para probar onboarding desde cero?')) return;

    const uid = user?.id;
    if (!uid) { alert('No user ID found'); return; }

    try {
      // Reset profile — only set onboarding_done false, keep membership
      const { error: profileErr } = await supabase.from('profiles').update({
        onboarding_done: false,
        profile_completed: false,
        updated_at: new Date().toISOString(),
      }).eq('id', uid);

      if (profileErr) { alert('Error resetting profile: ' + profileErr.message); return; }

      // Delete related data (ignore errors if tables empty)
      await supabase.from('user_intereses').delete().eq('user_id', uid).then(r => r.error && console.warn('intereses:', r.error.message));
      await supabase.from('pensamientos').delete().eq('user_id', uid).then(r => r.error && console.warn('pensamientos:', r.error.message));
      await supabase.from('posiciones_red').delete().eq('user_id', uid).then(r => r.error && console.warn('posiciones:', r.error.message));
      await supabase.from('sinapsis').delete().eq('user_from_id', uid).then(r => r.error && console.warn('sinapsis:', r.error.message));

      if (refreshProfile) await refreshProfile();
      window.location.href = '/onboarding';
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      background: 'rgba(0,0,0,0.5)', borderRadius: 12, padding: '6px 10px',
    }}>
      <span style={{ fontSize: 11, color: '#aaa', fontFamily: font, whiteSpace: 'nowrap' }}>Ver como:</span>
      <select
        value={viewAs || ''}
        onChange={e => handleChange(e.target.value)}
        style={{
          background: 'transparent', border: 'none', color: '#fff',
          fontSize: 12, fontFamily: font, fontWeight: 600, cursor: 'pointer',
          outline: 'none', padding: '2px 4px',
        }}
      >
        {OPTIONS.map(o => (
          <option key={o.label} value={o.value || ''} style={{ color: '#000' }}>
            {o.emoji} {o.label}
          </option>
        ))}
      </select>
      {viewAs && (
        <button
          onClick={() => { setViewAs(null); setTimeout(() => navigate('/admin'), 50); }}
          style={{
            background: C.coral, color: '#fff', border: 'none', borderRadius: 8,
            padding: '3px 8px', fontSize: 10, fontWeight: 600, cursor: 'pointer',
            fontFamily: font, whiteSpace: 'nowrap',
          }}
        >
          ← Admin
        </button>
      )}
      <button
        onClick={resetOnboarding}
        style={{
          background: 'rgba(253,190,2,0.15)', color: C.mango, border: '0.5px solid rgba(253,190,2,0.3)',
          borderRadius: 8, padding: '3px 8px', fontSize: 10, fontWeight: 600, cursor: 'pointer',
          fontFamily: font, whiteSpace: 'nowrap',
        }}
      >
        🔄 Reset
      </button>
    </div>
  );
}
